import { useQuery } from "urql";
import React, { useState } from "react";
import HistoryItem from "./HistoryItem";

const HistoryList = (props) => {
  return (
    <>
      {props.data.map((item, index) => (
        <HistoryItem {...item.node} key={index} />
      ))}
    </>
  );
};
export default HistoryList;
